import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexGeneral',
  setup(__props) {

const TotalSells = defineAsyncComponent(() => import("@/components/common/TotalSells.vue"))
const WebsiteDesign = defineAsyncComponent(() => import("@/components/theme/widgets/general/WebsiteDesign.vue"))
const OpeningLeaflets = defineAsyncComponent(() => import("@/components/common/OpeningLeaflets.vue"))
const VisitorsChart = defineAsyncComponent(() => import("@/components/theme/widgets/general/VisitorsChart.vue"))
const SocialWidget = defineAsyncComponent(() => import("@/components/theme/widgets/general/SocialWidget.vue"))
const StudentCard = defineAsyncComponent(() => import("@/components/common/StudentCard.vue"))
const AppointmentsData = defineAsyncComponent(() => import("@/components/common/AppointmentsData.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(TotalSells), { doller: "$ " }),
      _createVNode(_unref(WebsiteDesign)),
      _createVNode(_unref(OpeningLeaflets), {
        doller: "$",
        col: "col-xxl-3 col-xl-4 col-sm-6"
      }),
      _createVNode(_unref(VisitorsChart)),
      _createVNode(_unref(SocialWidget)),
      _createVNode(_unref(StudentCard)),
      _createVNode(_unref(AppointmentsData), {
        col: "col-xxl-6 col-xl-6 box-col-6 proorder-xl-7 proorder-md-8",
        bodyclass: "appointments relative pb-0"
      })
    ])
  ]))
}
}

})